import { render } from "./AdminView.vue?vue&type=template&id=24081026&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"

import "./AdminView.vue?vue&type=style&index=0&id=24081026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24081026"]])

export default __exports__